export default __webpack_public_path__ + "static/media/Interface2.88c24463.png";